module.exports = [
  { id: "t-botg", value: "BOTGs" },
  { id: "t-loi", value: "Ladder of Inference" },
  { id: "t-sfm", value: "Stock-Flow Maps" },
  { id: "t-ice", value: "Iceberg" },
  { id: "t-cl", value: "Causal Links" },
  { id: "t-cc", value: "Connection Circles" },
  { id: "t-cld", value: "Causal Loop Diagrams" },
];
